export const config = {
  APP_DESCRIPTION: '',
  APP_KEYWORDS: '',
  APP_SEARCH_URL: '/search',
  APP_THEME_COLOR: '',
  APP_TITLE: '',
  APP_TITLE_TEMPLATE: '',
  BASE_URL: '',
  COMSCORE_CLIENT_ID: 0,
  IDENTIFIER: '',
  NODE_ENV: '',
  PACKAGE_NAME: '',
  REPORT_LOG_ON_LEVELS: '',
};

export function setConfig (newConfig: Partial<typeof config>) {
  Object.assign(config, newConfig);
}
